/**
 * 목록 그리드의 열 규칙.
 *
 * 열 수를 브레이크포인트로 못 박지 않고 `auto-fit` 에 맡긴다 — 카드가 최소 595px 을 확보하는 만큼 열이 늘어난다.
 *
 * ⚠️ 열 수가 CSS 선택자에게는 보이지 않는다. `LIST_GRID_TWO_ROW_CLAMP` 가 그 값을 컨테이너 쿼리로
 * 되짚으므로 두 상수는 반드시 함께 고친다.
 */
/**
 * 카드 최소폭 595px, 가로 간격(`gap-x-xs`) 8px.
 * n 열이 들어가기 시작하는 컨테이너 폭 = n × 595 + (n − 1) × 8 → 2열 1198 · 3열 1801 · 4열 2404.
 * 아래 클래스 문자열과 컨테이너 쿼리의 리터럴은 이 공식에서 왔다.
 */

export const LIST_GRID_CLASSNAME =
  'grid max-tablet-sm:grid-cols-1 grid-cols-[repeat(auto-fit,minmax(595px,1fr))] gap-x-xs';

/**
 * 두 줄 규칙이 기준으로 삼는 컨테이너. 그리드를 바로 감싸는 요소에 준다.
 * 열 수는 그리드 자신의 폭으로 정해지므로 뷰포트가 아니라 이 컨테이너의 폭으로 판단한다.
 */
export const LIST_GRID_CONTAINER_CLASSNAME = '[container-type:inline-size]';

/**
 * 그리드를 두 줄까지만 보이게 자른다. `LIST_GRID_CONTAINER_CLASSNAME` 을 준 요소 안에서만 동작한다.
 *
 * 나머지는 `display:none` 이라 탭 순서에서도 빠진다.
 *
 * | 컨테이너 폭 | 열 | 보이는 칸 |
 * |---|---|---|
 * | ~1800px | 1~2 | 4 (`새 폴더` + 3) |
 * | 1801~2403px | 3 | 6 (`새 폴더` + 5) |
 * | 2404px~ | 4 | 8 (`새 폴더` + 7) |
 */
export const LIST_GRID_TWO_ROW_CLAMP = [
  '[@container(max-width:1800px)]:[&>*:nth-child(n+5)]:hidden',
  '[@container(min-width:1801px)_and_(max-width:2403px)]:[&>*:nth-child(n+7)]:hidden',
  '[@container(min-width:2404px)]:[&>*:nth-child(n+9)]:hidden',
].join(' ');

/** 두 줄 규칙이 가장 좁은 화면(1~2열)에서 그리는 카드 수. */
export const LIST_GRID_TWO_ROW_MIN_CELLS = 4;

/** 두 줄 규칙이 가장 넓은 화면에서 그리는 카드 수. 그만큼은 받아 둬야 빈칸이 안 생긴다. */
export const LIST_GRID_TWO_ROW_MAX_CELLS = 8;
